<template>
  <div>
    <CRow>
        <CCol>
            <div style="width:100%; height: 75vh;">
                <ejs-grid ref='gridr' :dataSource='ricData' :allowFiltering='true' :allowPaging='true' :allowResizing='true'
                          :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :editSettings='editSettings' :enablePersistence ="true"
                          :pageSettings='pageSettings' :filterSettings='filterOptions' :toolbarClick='toolbarClick' :actionBegin='actionBegin' :actionFailure="actionFailure" :actionComplete="actionComplete"
                          :allowExcelExport='true' :excelExportComplete='excelExportComplete' width="100%" height="100%">
                    <e-columns>
                        <e-column field='id' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='stateId' headerText='Country' :validationRules="requiredRules" width=120 :visible="false" :edit='stateParams' foreignKeyField='stateId' foreignKeyValue='stateName' :dataSource='states' editType='dropdownedit'></e-column>
                        <e-column field='stateName' headerText='Country' textAlign='Left' width=180 type="string"></e-column>
                        <e-column field='pricingAreaId' headerText='Price Area' width=180 :edit='pricingAreaParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='pricingAreas' editType='dropdownedit'></e-column>
                        <e-column field='utilityTypeId' headerText='Commodity' :validationRules="requiredRules" width=180 :edit='utilitiesParams' foreignKeyField='utilityTypeId' foreignKeyValue='utilityTypeName' :dataSource='utilities' editType='dropdownedit'></e-column>
                        <e-column field='activeMonth' headerText='Active Month' displayAsCheckBox='true' width=180 editType='booleanedit' type='boolean'></e-column>
                        <e-column field='core' headerText='Identifier' :validationRules="requiredRules" width=180></e-column>
                        <e-column field='coreExtension' headerText='Identifier Extension' width=180></e-column>
                        <e-column field='productId' headerText='Product' :validationRules="requiredRules" width=180 :edit='productParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='products' editType='dropdownedit'></e-column>
                        <e-column field='providerType'
                                  headerText='Provider Type'
                                  :validationRules="requiredRules"
                                  width=180
                                  :edit='providerTypeParams'
                                  foreignKeyField='id'
                                  foreignKeyValue='name'
                                  :dataSource='providerType'
                                  editType='dropdownedit'>
                        </e-column>
                        <e-column field='monthsAhead' headerText='Months Ahead' textAlign='Right' :validationRules='numericRules' editType='numericedit' :edit='numericParams' width=180></e-column>
                        <e-column field='quartersAhead' headerText='Quarters Ahead' textAlign='Right' :validationRules='numericRules' editType='numericedit' :edit='numericParams' width=180></e-column>
                        <e-column field='seasonssAhead' headerText='Seasons Ahead' textAlign='Right' :validationRules='numericRules' editType='numericedit' :edit='numericParams' width=180></e-column>
                        <e-column field='yearsAhead' headerText='Years Ahead' textAlign='Right' :validationRules='numericRules' editType='numericedit' :edit='numericParams' width=180></e-column>
                        <e-column field='parentId' headerText='Parent Identifier' textAlign='Right' editType='dropdownedit' :edit='ricParams' foreignKeyField="id" foreignKeyValue='core' :dataSource='rics' width=180></e-column>
                        <e-column field='benchmarkId' headerText='Benchmark Identifier' textAlign='Right' editType='dropdownedit' :edit='benchmarkRicParams' foreignKeyField="id" foreignKeyValue='core' :dataSource='rics' width=180></e-column>
                        <e-column field='description' headerText='Description' width=180></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
  </div>
</template>
<script>

    import Vue from "vue";
    import { mapState, mapActions } from 'vuex'
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { createElement } from '@syncfusion/ej2-base';
    import { DataManager, WebApiAdaptor, ODataV4Adaptor } from "@syncfusion/ej2-data";
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import axios from 'axios';
    import gridOptions from '../../../common/gridOptions'
    import SyncHelper from '../../../common/syncfusion'
    import store from '../../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);


    let dpStates, elStates, dpUtilities, elUtilities, dpProducts, elProducts, ricElem, ricObj, ricBElem, ricBObj, dpPricingArea, elPricingArea, providerTypeElem, providerTypeObj;

    export default {
        name: 'RIC',
        data() {
            return {
                store: store,
                ricData: SyncHelper.getDataManager("ric"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.Ric.Update"],
                    allowAdding: store.state.permissions["Permissions.Ric.Create"],
                    allowDeleting: store.state.permissions["Permissions.Ric.Delete"],
                    mode: 'Dialog'
                },
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 0,
                        format: "N"
                    }
                },
                requiredRules: { required: true },
                numericRules: { required: true, number: true },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                states: SyncHelper.getDataManager("utils/states"),
                products: SyncHelper.getDataManager("utils/products"), utilities: SyncHelper.getDataManager("utils/utilities"),
                pricingAreas: SyncHelper.getDataManager("utils/priceAreasWithoutStateName"),
                providerType: SyncHelper.getDataManager("utils/providerType"),
                currentStateId: null,


                rics: SyncHelper.getDataManager('Utils/rics'),
                ricParams: {
                    create: () => {
                        ricElem = document.createElement('input');
                        return ricElem;
                    },
                    read: () => {
                        return ricObj.value;
                    },
                    destroy: () => {
                        ricObj.destroy();
                    },
                    write: (args) => {
                        ricObj = new DropDownList({
                            dataSource: this.rics,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Parent Identifier',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                        });

                        if (this.currentStateId) {
                            let tempQuery = new Query().where('stateId', 'equal', this.currentStateId);
                            ricObj.query = tempQuery;
                            ricObj.text = null;
                            ricObj.dataBind();
                        }

                        ricObj.appendTo(ricElem);
                    }
                },
                benchmarkRicParams: {
                    create: () => {
                        ricBElem = document.createElement('input');
                        return ricBElem;
                    },
                    read: () => {
                        return ricBObj.value;
                    },
                    destroy: () => {
                        ricBObj.destroy();
                    },
                    write: (args) => {
                        ricBObj = new DropDownList({
                            dataSource: this.rics,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Benchmark Identifier',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                        });
                        ricBObj.appendTo(ricBElem);
                    }
                },
                stateParams: {
                    create: () => {
                        elStates = document.createElement('input');
                        return elStates;
                    },
                    read: () => {
                        return dpStates.value;
                    },
                    destroy: () => {
                        dpStates.destroy();
                    },
                    write: (args) => {
                        dpStates = new DropDownList({
                            dataSource: this.states,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Country',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                            change: (args) => {
                                let tempQuery = new Query().where('stateId', 'equal', dpStates.value);
                                dpPricingArea.query = tempQuery;
                                dpPricingArea.text = null;
                                dpPricingArea.dataBind();

                                ricObj.query = tempQuery;
                                ricObj.text = null;
                                ricObj.dataBind();

                                this.onStateChange(args);
                                //dpPricingArea.showPopup();
                            }
                        });
                        dpStates.appendTo(elStates);
                    }
                },
                providerTypeParams: {
                    create: () => {
                        providerTypeElem = document.createElement('input');
                        return providerTypeElem;
                    },
                    read: () => {
                        return providerTypeObj.value;
                    },
                    destroy: () => {
                        providerTypeObj.destroy();
                    },
                    write: (args) => {
                        providerTypeObj = new DropDownList({
                            dataSource: this.providerType,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Provider Type',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                        });
                        providerTypeObj.appendTo(providerTypeElem);
                    }
                },
                utilitiesParams: {
                    create: () => {
                        elUtilities = document.createElement('input');
                        return elUtilities;
                    },
                    read: () => {
                        return dpUtilities.value;
                    },
                    destroy: () => {
                        dpUtilities.destroy();
                    },
                    write: (args) => {
                        dpUtilities = new DropDownList({
                            dataSource: this.utilities,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Commodity',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                            change: (args) => {
                                dpProducts.enabled = true;
                                let tempQuery = new Query().where('utilityTypeId', 'equal', dpUtilities.value);
                                dpProducts.query = tempQuery;
                                dpProducts.text = null;
                                dpProducts.dataBind();
                                this.onUtilityChange(args);
                            },
                        });
                        dpUtilities.appendTo(elUtilities);
                    }
                },
                pricingAreaParams: {
                    create: () => {
                        elPricingArea = document.createElement('input');
                        return elPricingArea;
                    },
                    read: () => {
                        return dpPricingArea.value;
                    },
                    destroy: () => {
                        dpPricingArea.destroy();
                    },
                    write: (args) => {
                        dpPricingArea = new DropDownList({
                            dataSource: this.pricingAreas,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Price Area',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            actionComplete: this.priceAreaActionComplete,
                        });
                        if ((args.foreignKeyData && args.foreignKeyData[0])) {
                            let tempQuery = new Query().where('stateId', 'equal', dpStates.value);
                            dpPricingArea.query = tempQuery;
                        }
                        dpPricingArea.appendTo(elPricingArea);
                    }
                },
                productParams: {
                    create: () => {
                        elProducts = document.createElement('input');
                        return elProducts;
                    },
                    read: () => {
                        return dpProducts.value;
                    },
                    destroy: () => {
                        dpProducts.destroy();
                    },
                    write: (args) => {
                        dpProducts = new DropDownList({
                            dataSource: this.products,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Product',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                            enabled: ((args.foreignKeyData && args.foreignKeyData[0]) ? true : false)
                        });
                        if ((args.foreignKeyData && args.foreignKeyData[0])) {
                            let tempQuery = new Query().where('utilityTypeId', 'equal', dpUtilities.value);
                            dpProducts.query = tempQuery;
                        }
                        dpProducts.appendTo(elProducts);
                    }
                },
                filterOptions: gridOptions.filterSettings,
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Energy Instruments.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridr.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args, this.$refs);

                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.gridr.getColumns().length; i++) {

                    }
                }
     
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    this.$refs.gridr.getColumns()[1].visible = true;
                    this.$refs.gridr.getColumns()[2].visible = false;
                }
                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));


                }
               
                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }

                if (args.requestType == 'beginEdit')
                    this.currentStateId = args.rowData.stateId;
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));
                }
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["core", "monthsAhead", "quartersAhead", "seasonssAhead","yearsAhead"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }
                if (args.requestType === 'beginEdit') {
                    let ddPriceArea = document.querySelector('[id^="grid"][id$="pricingAreaId"]')
                    ddPriceArea.ej2_instances[0].enabled = false;
                    let ddState = document.querySelector('[id^="grid"][id$="stateId"]')
                    ddState.ej2_instances[0].enabled = false;
                    let ddCommodity = document.querySelector('[id^="grid"][id$="utilityTypeId"]')
                    ddCommodity.ej2_instances[0].enabled = false;
                    let chkActiveMonth = document.querySelector('[id^="grid"][id$="activeMonth"]')
                    chkActiveMonth.ej2_instances[0].disabled = true;
                    let txtCore = document.querySelector('[id^="grid"][id$="core"]')
                    txtCore.ej2_instances[0].enabled = true;
                    let txtCoreExtension = document.querySelector('[id^="grid"][id$="coreExtension"]')
                    txtCoreExtension.ej2_instances[0].enabled = true;
                    let ddProduct = document.querySelector('[id^="grid"][id$="productId"]')
                    ddProduct.ej2_instances[0].enabled = false;
                    //setTimeout(function () {
                    //    let ddPriceArea = document.querySelector('[id^="grid"][id$="pricingAreaId"]')
                    //    const itemCount = ddPriceArea.ej2_instances[0].listData ? ddPriceArea.ej2_instances[0].listData.length : 0;
                    //    if (itemCount == 0) {
                    //        ddPriceArea.ej2_instances[0].readonly = true;
                    //    }
                    //    else {
                    //        ddPriceArea.ej2_instances[0].readonly = false;
                    //    }
                    //}, 1000);
                }

            },

            priceAreaActionComplete(args) {
                let ddPriceArea = document.querySelector('[id^="grid"][id$="pricingAreaId"]')
                if (ddPriceArea) {
                    let parentDiv = ddPriceArea.closest('.e-input-group');
                    if (parentDiv) {
                        let elementForm = document.querySelector('[id^="grid"][id$="EditForm"]')
                        const formValidator = elementForm.ej2_instances[0];
                        if (args.result.length > 0) {
                            parentDiv.classList.add('required-input');
                            ddPriceArea.ej2_instances[0].readonly = false;
                            formValidator.addRules('pricingAreaId', { required: true });
                        }
                        else {
                            parentDiv.classList.remove('required-input');
                            setTimeout(function () {
                                //ddPriceArea.ej2_instances[0].hidePopup();
                                ddPriceArea.ej2_instances[0].readonly = true;
                                formValidator.addRules('pricingAreaId', { required: false });
                            }, 200);
                        }
                    }
                }
            },
            onStateChange(args) {
                if (args.isInteracted) {
                    var errorMsg = document.getElementById('pricingAreaId_Error');
                    let dpUtility = document.querySelector('[id^="grid"][id$="utilityTypeId"]').ej2_instances[0].text;
                    let ddPriceArea = document.querySelector('[id^="grid"][id$="pricingAreaId"]')
                    let elementForm = document.querySelector('[id^="grid"][id$="EditForm"]')
                    if (dpUtility == "Gas") {
                        const formValidator = elementForm.ej2_instances[0];
                        if (args.itemData.stateName == "Denmark" || args.itemData.stateName == "Sweden" || args.itemData.stateName == "Norway" || args.itemData.stateName == "Finland") {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.remove('required-input');
                            setTimeout(function () {
                                //ddPriceArea.ej2_instances[0].hidePopup();
                                ddPriceArea.ej2_instances[0].readonly = true;
                                ddPriceArea.ej2_instances[0].value = null;
                                ddPriceArea.ej2_instances[0].text = null;
                                ddPriceArea.ej2_instances[0].enabled = false;
                                formValidator.addRules('pricingAreaId', { required: false });
                            }, 300);

                            if (errorMsg != null) {
                                errorMsg.style = 'top: 230px; left: 100.5px; max-width: 282px; text-align: center; display: none';
                            }

                        }

                    } else {
                        const formValidator = elementForm.ej2_instances[0];
                        if (args.itemData.stateName == "Denmark" || args.itemData.stateName == "Sweden" || args.itemData.stateName == "Norway" || args.itemData.stateName == "Finland") {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.add('required-input');
                            setTimeout(function () {
                                //ddPriceArea.ej2_instances[0].showPopup();
                                ddPriceArea.ej2_instances[0].enabled = true;
                                ddPriceArea.ej2_instances[0].readonly = false;
                                formValidator.addRules('pricingAreaId', { required: true });
                            }, 300);
                            if (errorMsg != null) {
                                errorMsg.style = 'top: 230px; left: 100.5px; max-width: 282px; text-align: center; display: block';
                            }
                        }
                        else {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.remove('required-input');
                            parentDiv.classList.remove('e-error');
                            ddPriceArea.ej2_instances[0].readonly = true;
                            ddPriceArea.ej2_instances[0].value = null;
                            ddPriceArea.ej2_instances[0].text = null;
                            ddPriceArea.ej2_instances[0].enabled = false;
                            formValidator.addRules('pricingAreaId', { required: false });
                        }


                    }


                }

            },
            onUtilityChange(args) {
                if (args.isInteracted) {
                    var errorMsg = document.getElementById('pricingAreaId_Error');
                    let ddPriceArea = document.querySelector('[id^="grid"][id$="pricingAreaId"]')
                    let elementForm = document.querySelector('[id^="grid"][id$="EditForm"]')
                    if (args.itemData.utilityTypeName == "Gas") {
                        const formValidator = elementForm.ej2_instances[0];
                        let dpState = document.querySelector('[id^="grid"][id$="stateId"]').ej2_instances[0].text;
                        if (dpState == "Denmark" || dpState == "Sweden" || dpState == "Norway" || dpState == "Finland") {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.remove('required-input');
                            parentDiv.classList.remove('e-error');
                            ddPriceArea.ej2_instances[0].value = null;
                            ddPriceArea.ej2_instances[0].text = null;
                            ddPriceArea.ej2_instances[0].enabled = false;
                            formValidator.addRules('pricingAreaId', { required: false });

                            if (errorMsg != null) {
                                errorMsg.style = 'top: 230px; left: 100.5px; max-width: 282px; text-align: center; display: none';
                            }
                        }

                    }
                    else {
                        const formValidator = elementForm.ej2_instances[0];
                        let dpState = document.querySelector('[id^="grid"][id$="stateId"]').ej2_instances[0].text;
                        if (dpState == "Denmark" || dpState == "Sweden" || dpState == "Norway" || dpState == "Finland") {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.add('required-input');
                            setTimeout(function () {
                                //ddPriceArea.ej2_instances[0].showPopup();
                                ddPriceArea.ej2_instances[0].readonly = false;
                                ddPriceArea.ej2_instances[0].enabled = true;
                                formValidator.addRules('pricingAreaId', { required: true });
                            }, 300);
                            if (errorMsg != null) {
                                errorMsg.style = 'top: 230px; left: 100.5px; max-width: 282px; text-align: center; display: block';
                            }
                        }
                        else {
                            let parentDiv = ddPriceArea.closest('.e-input-group');
                            parentDiv.classList.remove('required-input');
                            parentDiv.classList.remove('e-error');
                            ddPriceArea.ej2_instances[0].readonly = true;
                            ddPriceArea.ej2_instances[0].value = null;
                            ddPriceArea.ej2_instances[0].text = null;
                            ddPriceArea.ej2_instances[0].enabled = false;
                            formValidator.addRules('pricingAreaId', { required: false });
                        }

                    }

                }


            },

            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>